import configuration from './configuration'
import detail from './detail'
import landing from './landing'

export default {
  helpers: {
    currency: '$%{value}',
    percent: '%{value}%',
    discounted: {
      default_item_label: 'Items that get discounted',
      default_modifier_label: 'Modifiers that get discounted',
      free_items: 'Free items',
      free_modifiers: 'Free modifiers',
      free_modifier_item: 'Items',
      free_modifier_item_fallback_help_text:
        'Enter the POS modifier IDs for modifiers customers can get for free.',
      free_modifier_item_fallback:
        'Enter the POS product IDs of items eligible for a free modifier.',
      modifier_restrictions: 'Modifier restrictions (optional)',
      free_modifier_item_help_text:
        'Choose what items are eligible for a free modifier.',
      free_item_modifiers_help_text:
        'Choose modifiers customers must add to the items above for this offer to apply.',
      modifier_base_item_help_text:
        'Modifiers are not included in the fixed price. Consumers will be charged their normal list price for any modifiers added.',
      modifier_required_modifiers_help_text:
        'Choose modifiers that are included for the fixed price. Any modifiers not listed will cost the consumer their normal list price.',
      free_item_modifiers_secondary_help_text:
        'Enter the Modifier IDs from your POS. Make sure to include all Modifier IDs that apply to the items selected above, separated by commas.',
      free_modifiers_help_text:
        'Choose which modifiers customers can get for free.',
      they_for_free: "They'll be eligible to get another item for free",
      they_discount: "They'll be eligible to get a discount on another item",
    },
  },
  landing,
  detail,
  templates_status: {
    published: 'active',
    unpublished: 'draft',
    archived: 'archived',
  },
  preview_card: {
    reward: 'offer',
    where_to_see: 'Where customers see this offer',
    reward_symbol: 'Offer symbol',
  },
  product_select: {
    free_item_title: 'Free Items',
    select_item: '0 items selected',
    search: 'Search',
    placeholder:
      'e.g: 1714, d6abb4fe-3fec-44ac-a9ca-c19d9ccd56f9, RM4SIETJ6F5SYNRQENFJPXYZ',
    help_text:
      'Enter product IDs from your POS, separated by commas or spaces.',
    invalid_id: 'Invalid product ID format',
    remove_id: 'Remove product ID',
    show_more: 'See more',
    learn_more_about_item: 'Learn more about this item.',
    guid: 'External Id',
    guid_info:
      'The ID Thanx gets from the ordering provider (e.g. CHAIN_UID for Olo; GUID for Toast)',
    price: 'Price',
    default_menu_name: 'Main Menu',
  },
  modifier_select: {
    free_modifier_label: 'Modifier restrictions',
    free_modifiers_help_text:
      'Enter the Modifier IDs. Make sure to include all Modifier IDs that apply to the items selected above, separated by commas.',
    delete: 'Delete modifier',
    select_modifier: '0 modifiers selected',
    resolving_selection: 'Loading %{count} selected modifier...',
    resolving_selection_plural: 'Loading %{count} selected modifiers...',
    search: 'Search',
    select_all: 'Select all',
    next_page: 'Next page',
    previous_page: 'Previous page',
    product_id_required: 'Product ID is required',
    count_selected: '%{count} selected',
    count_results: '%{count} results',
    start_end_of_total: '%{start} - %{end} of %{total}',
    show_more: 'See more',
    image_alt: 'Modifier option image',
    items_in_modifier_modal_subtitle:
      'This modifier can be applied to the following items you have selected in the "Items" section:',
    wrapper: {
      display: 'Add a modifier restriction',
      hide: 'Disable restrictions',
      display_modifier_discounts:
        'Advanced: Make some modifiers free, but not required.',
      hide_modifier_discounts:
        'Hide: Required and discounted modifiers are the same.',
      display_modifier_discount_ids:
        'Advanced: Make some modifier IDs free, but not required.',
      hide_modifier_discount_ids:
        'Hide: Required and discounted modifier IDs are the same.',
    },
    modifier_groups_title: 'Modifier Groups',
    modifier_groups_subtitle:
      'This modifier is nested under the following modifier group(s):',
    menus_title: 'Menus',
    menus_subtitle: 'This modifier can be found in the following menu(s):',
    items_in_modifier_modal_title: 'Eligible Items',
    guid: 'External Id',
    guid_info:
      'The ID Thanx gets from the ordering provider (e.g. CHAIN_UID for Olo; GUID for Toast)',
    learn_more_about_modifier:
      'Learn more about where this modifier can be found in the menu.',
    instore_validation_note: {
      directive: 'Note',
      content:
        'In-store validation works with all integrated POS. For other cases (e.g. Fishbowl, kiosks), confirm support with your partner or use manager comp.',
      learn_more: 'Learn more',
      support_article_url:
        'https://help.thanx.com/hc/en-us/articles/31085428024855-Using-modifiers-in-rewards',
    },
  },
  actions: {
    edit: 'Edit',
    activate: {
      action: 'Activate',
      title: 'Activate this offer template',
      headline:
        'Activating this offer template allows you and your team to start using it in campaigns, loyalty programs, and customer feedback.',
      description:
        "Don't worry, offers won't be sent to customers until you send a campaign or grant this offer when responding to customer feedback.",
      submit_button: 'Activate template',
      error: "Your offer template '%{name}' was unable to be activated.",
      success: "Your offer template '%{name}' has been activated.",
    },
    delete: {
      action: 'Delete',
      title: 'Delete this draft',
      description:
        "Are you sure you want to delete this draft? You won't be able to undo this action.",
      submit_button: 'Delete draft',
      error: "The draft '%{name}' was unable to be deleted.",
      success: "The draft '%{name}' has been deleted.",
    },
    archive: {
      action: 'Archive',
      title: 'Archive this offer template',
      headline:
        'Archiving templates you no longer use hides them from the offer selection dropdown in campaigns and in customer feedback.',
      description:
        'Active campaigns and loyalty programs that currently use this template will continue to issue offers. Customers who received an offer will still be able to redeem it.',
      submit_button: 'Archive template',
      error: "The offer template '%{name}' was unable to be archived.",
      success: "The offer template '%{name}' has been archived.",
    },
    cancel: 'Cancel',
  },
  send_a_test: {
    successful:
      'Your test offer was successfully sent. It may take a few minutes to receive it. Open your %{merchantName} app to redeem it.',
    modal: {
      title: 'Send a test to your %{merchantName} app',
      enter_emails:
        'Enter the email address you use to login to your <a href="https://signup.thanx.com/%{handle}/join" target="_blank">%{merchantName}</a> account.',
      it_may_take: '(It may take a few minutes to issue a test offer)',
      email_address: 'Email address',
      separate_emails:
        'Separate multiple email addresses with commas or spaces',
      cancel: 'Cancel',
      submit: 'Send test',
      info_box: {
        title: 'Testing online redemption',
        content_1:
          'When you receive your first test of this reward, the app or web experience will automatically redirect you to the hidden menu. This is how your customers will experience this reward.',
        content_2:
          'Subsequently viewing this reward, either by sending additional tests or by viewing on a different device, will not redirect you to the hidden menu because your hidden menu reward is already active on your account.',
      },
      successful:
        'Your test offer was successfully sent. It may take a few minutes to receive it. Open your %{merchantName} app to redeem it.',
    },
  },
  change_active_template_modal: {
    title: 'This will update all unused offers',
    changes_apply:
      'Your changes will apply to all unused offers, including those already issued to users.',
    multi_use_can_redeem_base: 'Users can now redeem this offer',
    multi_use_once: 'once',
    multi_use_times: '%{times} times',
    multi_use_daily: 'daily',
    multi_use_every_days: 'every %{days} days',
    multi_use_up_to_total: ' up to %{times} times total.',
    multi_use_set_duration:
      'You can set how long this offer remains active when you add it to a campaign.',
    note_label: 'Note:',
    multi_use_reached_limit:
      "Users who've already reached the redemption limit will not receive additional instances of this offer.",
    cancel: 'Cancel',
    okay: 'Okay',
  },
  builder: {
    page_title: 'Edit offer template | Thanx',
    edit: {
      success: "The offer template '%{name}' has been updated.",
    },
    leaving_page_confirmation: {
      title: 'Save this offer template?',
      description:
        'You are leaving this offer template. Would you like to save it before exiting?',
      save_exit: 'Save & exit',
      dont_save_exit: "Don't save & exit",
      invalid_form: 'Please fill all fields before saving the template.',
    },
    success_page: {
      all_done: "You're all done",
      template_is_active: 'Your offer template is active.',
      able_to_see:
        'You will now be able to see it when creating campaigns or responding to customer feedback.',
      go_to_rewards: 'Go to offers',
      go_to_campaigns: 'Go to campaigns',
    },
    error:
      'Something went wrong while creating the template. Please try again.',
    buttons: {
      enable: 'Enable',
      disable: 'Disable',
      next: 'Next',
    },
    top_bar: {
      type_tab: 'type',
      name_tab: 'name',
      configuration_tab: 'configuration',
      back: 'Go back',
    },
    preview: {
      title: 'what customers see',
      summary: 'summary',
      reward_type: 'offer type',
      online_redemption: 'online redemption',
      instore_redemption: 'in-store redemption',
      customer_support: 'customer support',
      discount: 'discount',
      not_configured: "You haven't configured this yet",
      online_available: 'Can redeem online',
      online_not_available: 'Cannot redeem online',
      limited_to: 'Limited to %{count} items',
      limited_to_1: 'Limited to %{count} item',
      must_buy: 'Customer must buy any of %{count} qualifying items',
      must_buy_1: 'Customer must buy an item',
      instore_available: 'Can redeem in-store',
      instore_not_available: 'Cannot redeem in-store',
      number_of_uses: 'Number of uses',
      exactly_once: 'Exactly once',
      multiple_times: 'Multiple times',
      support_available: 'Available for customer support',
      support_not_available: 'Not available for customer support',
      okay: 'Okay',
      where_to_see: 'Where customers see this offer',
      number_of_bonus_points: 'Number of bonus points',
      minimum_spend: 'Minimum spend',
      minimum_spend_must_spend: 'Must spend at least $%{amount} to redeem',
      maximum_discount: 'Maximum discount',
      maximum_discount_cannot_redeem: 'Cannot redeem more than $%{amount}',
      no_restriction: 'No restriction',
      examples: {
        email:
          'When you send your campaign, customers will see the offer in your email, push, or SMS',
        appList:
          "When customers view the offers page in the app, they'll see available offers",
        web: "When customers are placing an order online, they'll see available offers in the offer dropdown",
        appDetail:
          "When customers click on the offer, they'll be able to see the offer details",
        cart: "When customers are placing an order online or in the app, they'll see available offers at the top of the cart",
      },
    },
    steps: {
      type: {
        title: 'Offer templates',
        non_discount: 'Non-Discount',
        discount: 'Free Items and Discounts',
        continue: 'Continue',
        need_different: 'Need to create a different type of offer? ',
        contact_us: 'Contact us',
        browse: 'Browse ideas',
        hidden_menu: {
          title: 'Hidden menu',
          subtitle: 'Give customers exclusive access to hidden menus',
        },
        golden_ticket: {
          title: 'Access pass',
          subtitle:
            'Offer custom digital and in-store experiences, gifts, and more',
          subtitle_disabled: 'Coming soon!',
        },
        bonus_points: {
          title: 'Bonus points',
          subtitle:
            'Give customers points to inspire engagement with your loyalty program',
          subtitle_disabled: 'Coming soon!',
        },
        delivery_discount: {
          title: 'Delivery discount',
          subtitle:
            'Give customers an offer that lowers or waives delivery fees',
        },
      },
      name: {
        title: 'Offer name',
        description:
          'This is how it will appear in your offer list when you create campaigns',
        visible_to_you:
          'This is only visible to you. It will not appear to your customers.',
        input_label: 'Name',
        continue: 'Continue',
        save_exit: 'Save & Exit',
      },
      configuration,
    },
    requires_olo: {
      title: 'Requires Thanx Ordering and Olo or Toast for online redemption.',
      learn_more: 'Learn more',
    },
  },
  types: {
    example: 'example',
    free_item: {
      title: 'free',
    },
    discount: {
      title: 'discount',
    },
    buy_one_get_one: {
      title: 'buy one, get one',
    },
    buy_x_get_discount: {
      title: 'buy x, get discount off entire purchase',
    },
    fixed_price: {
      title: 'fixed price',
    },
    get_a_free_item: {
      title: 'Get a free item',
      preview: 'Free item',
      example: `
      <p>Customer gets a free item (with or without modifiers):</p>
      <ul>
        <li>Free dessert</li>
        <li>Free small pizza</li>
        <li>Free burrito with guacamole</li>
        <li>Free salad with any protein except shrimp</li>
      </ul>
      `,
      example_without_modifiers: 'Get a free dessert',
      description_example: 'Get a free dessert',
    },
    get_a_free_modifier: {
      title: 'Get a free modifier',
      preview: 'Free modifier',
      example: `
      <ul>
        <li>Free guac on all items</li>
        <li>Free protein on salads</li>
        <li>Free whipped cream on Berry Milkshake</li>
      </ul>
      `,
      description_example: 'Get a free side of guacamole',
    },
    'get_%_off_purchase': {
      title: 'Get % off entire purchase',
      preview: '%{discount}% off entire purchase',
      example: 'Customer gets 10% off their purchase',
      description_example: '20% off your purchase',
    },
    'get_%_off_item': {
      title: 'Get % off an item',
      preview: '%{discount}% off an item',
      example: 'Customer gets 20% off a burger',
      description_example: '20% off a burger',
    },
    get_$_off_purchase: {
      title: 'Get $ off entire purchase',
      preview: '$%{discount} off entire purchase',
      example: 'Customer gets $5 off their purchase',
      description_example: '$5 off their purchase',
    },
    get_$_off_item: {
      title: 'Get $ off an item',
      preview: '$%{discount} off an item',
      example: 'Customer gets $5 off a burger',
      description_example: '$5 off a burger',
    },
    'buy_x_get_%_off_purchase': {
      title: 'Buy item X, get % off entire purchase',
      preview: '%{discount}% off entire purchase',
      example: 'When a customer buys a burger, they get 10% off their purchase',
      description_example: 'Buy a burger, get 10% off your purchase',
    },
    'buy_item_get_%_off_item': {
      title: 'Buy one item, get % off another item',
      preview: 'Buy one item, get %{discount}% off another item',
      example:
        'Buy a burger, get 50% off your second burger<br/>OR<br/>Buy a burger, get 50% off fries.',
      description_example:
        'Get 50% off a burger when you buy another burger.<br/>OR<br/>Get 50% off fries when you buy a burger.',
    },
    buy_x_get_$_off_purchase: {
      title: 'Buy item X, get $ off entire purchase',
      preview: '$%{discount} off entire purchase',
      example: 'When a customer buys a burger, they get $5 off their purchase',
      description_example: 'Buy a burger, get $5 off your purchase',
    },
    buy_item_get_$_off_item: {
      title: 'Buy one item, get $ off another item',
      preview: 'Buy one item, get $%{discount} off another item',
      example:
        'Buy a burger, get $2 off your second burger<br/>OR<br/>Buy a burger, get $2 off fries.',
      description_example:
        'Get $2 off a burger when you buy another burger.<br/>OR<br/>Get $2 off fries when you buy a burger.',
    },
    buy_one_get_free_one: {
      title: 'Buy one item, get another item for free',
      preview: 'Buy one item, get another item for free',
      example:
        'Buy a burger, get a free burger<br/>OR<br/>Buy a burger, get free fries.',
      description_example:
        'Get a free burger when you buy another burger.<br/>OR<br/>Get free fries when you buy a burger.',
    },
    any_item_for_$x: {
      title: 'Get an item for a fixed price',
      preview: 'Any item for $%{priceCap}',
      example: 'Customer gets a burger for $5',
      description_example: 'Any entrée for $5.99',
    },
    any_modifier_for_$x: {
      title: 'Get a modifier for a fixed price',
      preview: 'Any modifier for $%{priceCap}',
      example: 'When a customer buys a burger, they can add bacon for $0.50',
      description_example: 'Bacon on any burger for $0.50',
    },
    free_fixed_price_item: {
      title: 'Get a free item',
      preview: 'Free item',
      example: 'Customer gets a free item.',
      description_example: 'Free entrée',
    },
    delivery_discount: {
      title: 'Delivery discount',
      preview: 'FREE DELIVERY',
      subtitle: 'Give customers an offer that lowers or waives delivery fees',
      example:
        'Customer gets free delivery on orders over $20 (or a discounted delivery fee).',
      description_example: 'Free delivery on orders $20+',
    },
    hidden_menu: {
      title: 'Hidden menu',
      preview: 'Hidden menu',
    },
    golden_ticket: {
      title: 'Access pass',
      preview: 'Access pass',
    },
    bonus_points: {
      title: 'Bonus points',
      preview: '%{points} bonus %{currencyName}',
    },
  },
}
